.chip {
  --btn-default-border-radius: var(--border-radius-xs);
}
